import React from 'react';
// import { useForm } from 'react-hook-form';
import { OnboardingFormStepLayout } from '@features/onboarding/layouts/OnboardingFormStepLayout';
import { useIsW2Mode } from '@features/w2/store/w2-mode';
import { W2_WELCOME_IMAGE } from '@features/w2/copy';
import { useGeneralStore } from 'src/store';

export const WelcomeForm = () => {
  const { siteConfig } = useGeneralStore();
  // W2-mode divergence (reactive read, per the store-flag convention): W2 ALWAYS
  // shows `W2_WELCOME_IMAGE`, overriding any employer `siteConfig.images.welcome`
  // (captain, 2026-07-21), so this screen and the `/select-plans` welcome are the
  // SAME image on every W2 group. B2C is byte-identical when the flag is off.
  const isW2 = useIsW2Mode();

  return (
    <OnboardingFormStepLayout onlyImage={true}>
      <img
        src={isW2 ? W2_WELCOME_IMAGE : (siteConfig?.images?.welcome ?? '')}
        alt=""
        className="w-full h-full object-cover object-top rounded-2xl"
      />
    </OnboardingFormStepLayout>
  );
};
